import {Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthService} from '../auth/auth.service';
import {Principal} from '../auth/principal.service';
import {UserRole} from '../auth/user-role.model';

/**
 * Blocks ADVERTISER / FINANCE from `/dashboard` (SRS-47: GET /api/dashboard/** is forbidden).
 * Redirects them to `/reports` before the dashboard module loads.
 */
@Injectable()
export class DashboardAccessGuard {

  constructor(
    private authService: AuthService,
    private principal: Principal,
    private router: Router,
  ) {
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.identity().pipe(
      map(() => {
        const roles = this.principal.getUser()?.roles ?? [];
        const isAdvertiserOrFinance =
          roles.includes(UserRole.ADVERTISER) || roles.includes(UserRole.FINANCE);
        const hasHigherPriority = roles.some(role => [
          UserRole.ADMIN,
          UserRole.SUPER_ADMIN,
          UserRole.READ_ONLY_ADMIN,
          // USER/READONLY_USER are what the backend actually issues now (fold of
          // CAMPAIGN_MANAGER/DESIGNER and SALES_REPRESENTATIVE/REV_OPS respectively - see
          // user-role.model.ts); the legacy roles are never present in a real user's roles[].
          UserRole.USER,
          UserRole.READONLY_USER,
        ].includes(role as UserRole));

        if (isAdvertiserOrFinance && !hasHigherPriority) {
          return this.router.parseUrl('/reports');
        }
        return true;
      })
    );
  }
}
